import { render } from "./designCoffe.vue?vue&type=template&id=55905616"
import script from "./designCoffe.vue?vue&type=script&lang=js"
export * from "./designCoffe.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__